import type { KinStep, Sex } from './types';

/** A stretch of a path that reads as one word: "father", "grandfather", "half-brother", "wife". */
export interface Segment {
  rel: 'up' | 'down' | 'sibling' | 'spouse';
  /** Generations covered (1 for a sibling or spouse). */
  depth: number;
  sex: Sex;
  half: boolean;
}

/**
 * Groups a path into words for the "how you're related" line. A run of parents keeps its first step on
 * its own, so the side of the family stays visible ("father’s grandfather", not "great-grandfather");
 * a run of children becomes one word ("grandson").
 */
export function segments(path: readonly KinStep[]): Segment[] {
  const out: Segment[] = [];
  for (let i = 0; i < path.length; ) {
    const s = path[i]!;
    if (s.rel === 'parent' || s.rel === 'child') {
      let j = i;
      while (j + 1 < path.length && path[j + 1]!.rel === s.rel) j++;
      const n = j - i + 1;
      const last = path[j]!;
      if (s.rel === 'parent') {
        out.push({ rel: 'up', depth: 1, sex: s.sex, half: false });
        if (n > 1) out.push({ rel: 'up', depth: n - 1, sex: last.sex, half: false });
      } else {
        out.push({ rel: 'down', depth: n, sex: last.sex, half: false });
      }
      i = j + 1;
    } else {
      out.push({ rel: s.rel, depth: 1, sex: s.sex, half: s.half });
      i++;
    }
  }
  return out;
}
